import { render, staticRenderFns } from "./LetterOfWishes.vue?vue&type=template&id=4ec8fad8&scoped=true"
import script from "./LetterOfWishes.vue?vue&type=script&lang=js"
export * from "./LetterOfWishes.vue?vue&type=script&lang=js"
import style0 from "./LetterOfWishes.vue?vue&type=style&index=0&id=4ec8fad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8fad8",
  null
  
)

export default component.exports